module.exports = __webpack_public_path__ + "static/media/go-apps-icon-tm-reversed.31925c5c.svg";